import { types } from "mobx-state-tree";

export const AvailableMonth = types.model("AvailableMonth", {
	count: types.number,
	d: types.number,
	yymm: types.number,
});

export type IAvailableMonth = typeof AvailableMonth.Type;
